define('lq/chatHub',[
    'lq',
    'lq/hubFactory'
], function (lq, createHub) {
    return createHub({
        hubName: 'chatHub',
        hubUrl: '/ChatHub',
        queryParams: { }
    });
});
